/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useState } from "react";

export const TaskContext = createContext({
  taskId: "",
  setTaskId: (value: string) => {},
});

export const TaskContextProvider = (props: any) => {
  /**
   *
   * @param taskId
   */
  const setTaskId = (taskId: string) => {
    setState({ ...state, taskId: taskId });
  };

  const initState = {
    taskId: "",
    setTaskId: setTaskId,
  };

  const [state, setState] = useState(initState);

  return (
    <TaskContext.Provider value={state}>{props.children}</TaskContext.Provider>
  );
};
